import type { ForManagerLocationDetail } from "@sidegigllc/api/client";
import { queries as gigInfoSidebarQueries } from "domains/gigs/containers/GigInfoSidebar/queries";
import { type GigView, isDesktopViewport, resolveGigView } from "domains/gigs/containers/ViewSwitcher/gigView";
import { queries as calendarQueries } from "domains/schedule/containers/Calendar/queries";
import { queries as filtersQueries } from "domains/schedule/containers/Filters/queries";
import { type GigBoardArgs, queries as gigBoardQueries } from "domains/schedule/containers/GigBoard/queries";
import type { MarketplaceSearch } from "domains/schedule/utils/useMarketplaceSearch";
import type { WarmableQuery } from "routing/warmQueries";

export type QueriesInput = {
  search: MarketplaceSearch;
  location: ForManagerLocationDetail | undefined;
  defaultView: GigView;
  now: Date;
  isAdmin: boolean;
  queryArgs: (now: Date) => GigBoardArgs;
  includeWorkingInterviews?: boolean;
};

export const queries = ({
  search,
  location,
  now,
  isAdmin,
  defaultView,
  queryArgs,
  includeWorkingInterviews,
}: QueriesInput): Array<WarmableQuery> => {
  const view = resolveGigView({ view: search.view, isDesktop: isDesktopViewport(), defaultView });
  return [
    ...(view === "list"
      ? gigBoardQueries({ search, location, now, isAdmin, queryArgs, includeWorkingInterviews })
      : calendarQueries({ search, location, includeWorkingInterviews })),
    ...filtersQueries(),
    ...gigInfoSidebarQueries({ search }),
  ];
};
